module.exports = __webpack_public_path__ + "img/chuan.c2ea30d7.png";